import React, { useEffect, useRef, useState } from 'react'
import { filteredCategories, handleAddSingleDataFormData, handleBlurData, handleInputChangeData, handleUpdateSingleData, handleUpdateSingleDataUrlEncoded, resetFormData } from '../../../Utils/helper';
import { getApi } from '../../../Services/apiService';
import { AsyncPaginate } from 'react-select-async-paginate';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

function EditPrepackProduct({ formData, setMethodType, type, setFormData, formDataCopy, productToEdit, setError, touched, setTouched, fetchPrepackProducts, setIsLoading, errors, isLoading, setSearchTerm, searchTerm, filterDatas, setFilterData }) {
  const dropdownRef = useRef()
  const [showStatusOptions, setShowStatusOptions] = useState(false)
  const [loading, setLoading] = useState(false)
  const [dataLoading, setDataLoading] = useState(false)
  const requiredFields = [
    'raw_product_id',
    'finished_product_id',
    'convert_type',
    'prepack_type',
    'estimate_shrinkage',
    'process_day',
  ]
  useEffect(() => {
    if (type === 'view' || type === 'edit' || type === 'clone') {
      handleGetEditData()
    }
    // handleChange()
  }, [])

  const handleGetEditData = async () => {
    try {
      setDataLoading(true);
      const resp = await getApi(`/prepack-product/${productToEdit?.id}`)
      if (resp?.success) {
        // If any key is null, set it to empty string
        const prepackProduct = resp?.data?.prepackProduct || {};
        const newFormData = {};
        Object.keys(prepackProduct).forEach(key => {
          newFormData[key] = prepackProduct[key] === null ? '' : prepackProduct[key];
        });
        
        // If cloning, clear fields that shouldn't be cloned
        // Only keep: Finished Product, PA Code, Convert Type, Prepack Type, Estimate Shrinkage%, Process Day
        if (type === 'clone') {
          newFormData.id = '';
          newFormData.raw_product_id = '';
          newFormData.raw_product_name_tc = '';
          newFormData.raw_product_code = '';
          newFormData.barcode = '';
          newFormData.special_period_from = '';
          newFormData.special_period_to = '';
        }
        
        setFormData(newFormData);
      }
    } catch (error) {
      console.error('Error fetching prepack product data:', error);
    } finally {
      setDataLoading(false);
    }
  }
 

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowStatusOptions(false)
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (searchTerm !== '') {
      setFilterData(filterDatas.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase())))
    }
  }, [searchTerm])
  const loadProducts = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    try {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('per_page', 20);

      // Only add search if it exists
      if (inputValue) {
        params.append('search', inputValue);
      }

      setLoading(true);
      const productsResponse = await getApi(`/product?${params.toString()}`);

      if (!productsResponse?.success) {
        return {
          options: [],
          hasMore: false,
          additional: {
            page: page + 1,
          },
        };
      }

      const products = productsResponse.data?.products?.data || [];
      const pagination = productsResponse.data?.products || {};

      const newOptions = products.map((product) => ({
        value: product.id,
        label: `${product.name_tc} | (${product.code})`,
        productObject: product,
      }));

      return {
        options: newOptions,
        hasMore: pagination.current_page < pagination.last_page,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      console.error('Error loading products:', error);
      return {
        options: [],
        hasMore: false,
        additional: {
          page: page + 1,
        },
      };
    } finally {
      setLoading(false);
    }
  };
  return (
    <div class="row">
      <div class="col-sm-12">
        <div class="setting-right position-relative setting-right-table edit-prepack">
          <h3>{type === 'edit' ? 'Edit' : (type === 'view' ? 'View' : (type === 'clone' ? 'Clone' : 'Add'))} Product</h3>
          <img src={window.getPublicUrl('/assets/images/close.svg')} class="close" alt="" onClick={() => {
            setMethodType('');
            resetFormData(setFormData, setError, productToEdit, formDataCopy);
            setError(null)
          }} />
          {dataLoading ? (
            <div className="setting-inner d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
              <div className="spinner-border spinner-border-lg" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
          <>
          <div class="setting-inner">
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="rawProduct">Raw Product<strong>*</strong></label>
                  <AsyncPaginate
                    value={
                      formData.raw_product_id
                        ? {
                          value: formData.raw_product_id,
                          label: `${formData.raw_product_name_tc} | (${formData.raw_product_code})`,
                        }
                        : null
                    }
                    loadOptions={loadProducts}
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        setFormData((prev) => ({
                          ...prev,
                          raw_product_id: selectedOption.value,
                          raw_product_name_tc: selectedOption.productObject.name_tc ,
                          raw_product_code: selectedOption.productObject.code,
                        }));
                        if (errors?.raw_product_id) {
                          setError((prev) => ({ ...prev, raw_product_id: '' }));
                        }
                      } else {
                        setFormData((prev) => ({
                          ...prev,
                          raw_product_id: null,
                          raw_product_name_tc: '',
                          raw_product_code: '',
                        }));
                      }
                    }}
                    placeholder="Search and select raw product..."
                    isClearable
                    isLoading={loading}
                    additional={{
                      page: 1,
                    }}
                    isDisabled={type === 'view'}
                    classNames={{
                      control: (state) =>
                        `my-custom-control ${state.isFocused ? 'is-focused' : ''}`,
                    }}
                    noOptionsMessage={() => 'No products found'}
                  />
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="finishedProduct">Finished Product<strong>*</strong></label>
                  <AsyncPaginate
                    value={
                      formData.finished_product_id
                        ? {
                          value: formData.finished_product_id,
                          label: `${formData.finished_product_name_tc} | (${formData.finished_product_code})`,
                        }
                        : null
                    }
                    loadOptions={loadProducts}
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        setFormData((prev) => ({
                          ...prev,
                          finished_product_id: selectedOption.value,
                          finished_product_name_tc: selectedOption.productObject.name_tc || '',
                          finished_product_code: selectedOption.productObject.code || '',
                        }));
                        if (errors?.finished_product_id) {
                          setError((prev) => ({ ...prev, finished_product_id: '' }));
                        }
                      } else {
                        setFormData((prev) => ({
                          ...prev,
                          finished_product_id: null,
                          finished_product_name_tc: '',
                          finished_product_code: '',
                        }));
                      }
                    }}
                    placeholder="Search and select finished product..."
                    isClearable
                    isLoading={loading}
                    isDisabled={type === 'view'}
                    
                    additional={{
                      page: 1,
                    }}
                    classNames={{
                      control: (state) =>
                        `my-custom-control ${state.isFocused ? 'is-focused' : ''}`,
                    }}
                    noOptionsMessage={() => 'No finished products found'}
                  />
                </div>
              </div>
              






        


              <div class="col-sm-4">
                <div class="form-group">
                  <label for="paCode">PA Code</label>
                  <input type="text" id="paCode" class="form-control" name='pa_code' value={formData?.pa_code} onChange={(e) => handleInputChangeData(e, setFormData, touched, setError)} onBlur={(e) => handleBlurData(e, setTouched, setError, 'PA Code')} disabled={type === 'view'} />
                  {/* {errors?.pa_code && (
                    <div className="invalid-feedback d-block">{errors.pa_code}</div>
                  )} */}
                </div>
              </div>


              <div class="col-sm-4">
                <div class="form-group">
                  <label for="barcode">Barcode</label>
                  <input type="text" id="barcode" class="form-control" name='barcode' value={formData?.barcode} onChange={(e) => handleInputChangeData(e, setFormData, touched, setError)} onBlur={(e) => handleBlurData(e, setTouched, setError, 'Barcode')} disabled={type === 'view'} />
                  {/* {errors?.barcode && (
                    <div className="invalid-feedback d-block">{errors.barcode}</div>
                  )} */}
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="convertType">Convert Type<strong>*</strong></label>
                  {/* //dropdown with PC, Weight */}
                  <select id="convertType" class="form-control" name='convert_type' value={formData?.convert_type} onChange={(e) => handleInputChangeData(e, setFormData, touched, setError)} onBlur={(e) => handleBlurData(e, setTouched, setError, 'Convert Type')} disabled={type === 'view'}>
                    <option value="">Select Convert Type</option>
                    <option value="PC">PC</option>
                    <option value="Weight">Weight</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label for="prepackType">Prepack Type<strong>*</strong></label>
                  {/* //dropdown with A, B, C */}
                  <select id="prepackType" class="form-control" name='prepack_type' value={formData?.prepack_type} onChange={(e) => handleInputChangeData(e, setFormData, touched, setError)} onBlur={(e) => handleBlurData(e, setTouched, setError, 'Prepack Type')} disabled={type === 'view'}>
                    <option value="">Select Prepack Type</option>
                    <option value="A">A</option>
                    <option value="B">B</option>
                    <option value="C">C</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="estimateShrinkage">Estimate Shrinkage%<strong>*</strong></label>
                  <input type="text" id="estimateShrinkage" class="form-control" name='estimate_shrinkage' value={formData?.estimate_shrinkage} onChange={(e) => handleInputChangeData(e, setFormData, touched, setError)} onBlur={(e) => handleBlurData(e, setTouched, setError, 'Estimate Shrinkage%')} disabled={type === 'view'} />
                  {errors?.estimate_shrinkage && (
                    <div className="invalid-feedback d-block">{errors.estimate_shrinkage}</div>
                  )}
                </div>
              </div>
              {/* <div class="col-sm-4">
                <div class="form-group">
                  <label for="convertRatio">Convert Ratio</label>
                  <input type="text" id="convertRatio" class="form-control" name='convert_ratio' value={formData?.convert_ratio} onChange={(e) => handleInputChangeData(e, setFormData, touched, setError)} onBlur={(e) => handleBlurData(e, setTouched, setError, 'Convert Ratio')} disabled={type === 'view'} />
                </div>
              </div> */}
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="processDay">Process Day<strong>*</strong></label>
                  <input type="text" id="processDay" class="form-control" name='process_day' value={formData?.process_day} onChange={(e) => handleInputChangeData(e, setFormData, touched, setError)} onBlur={(e) => handleBlurData(e, setTouched, setError, 'Process Day')} disabled={type === 'view'} />
                  {errors?.process_day && (
                    <div className="invalid-feedback d-block">{errors.process_day}</div>
                  )}
                </div>
              </div>

              <div class="col-sm-4">
                <div className="form-group">
                  <label htmlFor="specialPeriodFrom">Special Period From</label>
                  <DatePicker
                    id="specialPeriodFrom"
                    className="form-control"
                    name="special_period_from"
                    value={formData?.special_period_from ? dayjs(formData.special_period_from, 'YYYY/MM/DD') : null}
                    onChange={(date) => {
                      setFormData((prev) => ({
                        ...prev,
                        special_period_from: date ? date.format('YYYY-MM-DD') : '',
                      }));
                    }}
                    format="YYYY/MM/DD"
                    disabled={type === 'view'}
                  />
                </div>
              </div>
              <div class="col-sm-4">
                <div className="form-group">
                  <label htmlFor="specialPeriodTo">Special Period To</label>
                  <DatePicker
                    id="specialPeriodTo"
                    className="form-control"
                    name="special_period_to"
                    value={formData?.special_period_to ? dayjs(formData.special_period_to, 'YYYY/MM/DD') : null}
                    onChange={(date) => {
                      setFormData((prev) => ({
                        ...prev,
                        special_period_to: date ? date.format('YYYY-MM-DD') : '',
                      }));
                    }}
                    format="YYYY/MM/DD"
                    disabled={type === 'view'}
                  />
                </div>
              </div>

            </div>
          </div>

          <div class="button-settings">
            <div class="col-sm-12">
              <div class="d-flex justify-content-end gap-3">
                {type === 'view' ? (
                  <button class="reset" onClick={() => setMethodType('')}>Back</button>
                ) : (
                  <>
                    <button class="reset" onClick={() => { resetFormData(setFormData, setError, productToEdit, formDataCopy); type !== 'add' && handleGetEditData() }}>Reset</button>
                    {type === 'edit' ?
                      <button class="save" onClick={() => handleUpdateSingleDataUrlEncoded(productToEdit, setIsLoading, fetchPrepackProducts, formData, setMethodType, setFormData, setError, setTouched, `/prepack-product/${productToEdit?.id}`, 'prepackProduct', formDataCopy, requiredFields)} disabled={isLoading}>{isLoading ? 'Saving...' : 'Save'}</button>
                      :
                      <button class="save" onClick={() => handleAddSingleDataFormData(setIsLoading, fetchPrepackProducts, formData, setMethodType, setFormData, setError, setTouched, `/prepack-product`, 'prepackProduct', formDataCopy, requiredFields)} disabled={isLoading}>{isLoading ? 'Saving...' : 'Save'}</button>
                    }
                  </>
                )}
              </div>
            </div>
          </div>
          </>
          )}
        </div>
      </div>
    </div>
  )
}

export default EditPrepackProduct